<sc-dialog-title>
  <sc-dictionary-label dictionaryKey="tmc-yard.dialog.transport-option.title"></sc-dictionary-label>
</sc-dialog-title>

<sc-padding>
  <div class="content no-field-space">
    <sc-flex fitHeight stretchContent>
      <sc-flex-fitting-content>
        <sc-flex fitHeight vertical stretchContent>
          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="tmc-yard.dialog.transport-option.selected-title"></sc-dictionary-label>
          </sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex-fitting-content vertical>
            <sc-scroll-pane>
              @for (value of selectedValues; track value; let i = $index) {
              @if (i>0) {
              <sc-content-spacer [half]="true" vertical></sc-content-spacer>
              }
              <sc-data-set-tile [light]="i % 2 === 0">
                <sc-padding>
                  <sc-flex>
                    {{value.label}}
                    <sc-content-spacer grow></sc-content-spacer>
                    <sc-action-icon iconClass="fa-minus" (click)="remove(value)"></sc-action-icon>
                  </sc-flex>
                </sc-padding>
              </sc-data-set-tile>
              }
            </sc-scroll-pane>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-flex-fitting-content>
      <sc-content-spacer></sc-content-spacer>
      <sc-flex-fitting-content>
        <sc-flex fitHeight vertical stretchContent>
          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="tmc-yard.dialog.transport-option.available-title"></sc-dictionary-label>
          </sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>
          <form [formGroup]="formGroup">
            <sc-flex>
              <sc-string-field formControlName="query" grow label="Suche"></sc-string-field>
            </sc-flex>
          </form>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex-fitting-content vertical>
            <sc-scroll-pane>
              @for (value of filteredValues; track value; let i = $index) {
              @if (i>0) {
              <sc-content-spacer [half]="true" vertical></sc-content-spacer>
              }
              <sc-data-set-tile [light]="i % 2 === 0">
                <sc-padding>
                  <sc-flex>
                    @if (!value.assigned) {
                    <sc-action-icon iconClass="fa-plus" (click)="add(value)"></sc-action-icon>
                    }
                    @if (value.assigned) {
                    <sc-icon iconClass="fa-square-check"></sc-icon>
                    }
                    <sc-content-spacer></sc-content-spacer>
                    {{value.label}}
                  </sc-flex>
                </sc-padding>
              </sc-data-set-tile>
              }
            </sc-scroll-pane>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-flex-fitting-content>
    </sc-flex>
  </div>
</sc-padding>

<sc-padding>
  <sc-flex>
    <sc-content-spacer grow></sc-content-spacer>
    <sc-cancel-button (click)="cancel()"> </sc-cancel-button>
    <sc-content-spacer></sc-content-spacer>
    <sc-confirm-button primary (click)="confirm()"> </sc-confirm-button>
  </sc-flex>
</sc-padding>
